import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'datasets',
    props: true,
    meta: {
      middleware: [loggedIn]
    },
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    children: [
      {
        path: ':id',
        name: 'datasetsTableComponent',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "appTableComponent" */ './item/index.vue'
          ),
        meta: {
          rootRouteName: 'datasets'
        }
      },
      {
        path: ':id/:nestedId',
        name: 'datasetsNestedComponent',
        props: true,
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'datasets' }
  }
];
